import styled from 'styled-components';

export const CabinTitle = styled.h5`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 20px;
  color: #332927;
`;
